export default __webpack_public_path__ + "static/media/three_color_drink.97a6f7c2.JPG";